import * as $ from "jquery";
import * as _ from "lodash";
import { BaseDashboardWidgetView, BaseDashboardWidgetViewOptions } from "../_BaseWidgetView";
import { CHART_SIZE } from "../chart/ChartHelper";

declare var App: any;

export class IframeWidget extends BaseDashboardWidgetView {
    
    protected template = _.template(require("templates/dashboard/widgets/iframe/iframe.html"));

    constructor(options: BaseDashboardWidgetViewOptions) {
        super(<any>_.merge({
            tagName: "div",
            className: 'widget iframe-widget',
            events: {
                // Widget related buttons
                "click .w-settings .remove": "handleRemoveWidgetClick",
                "click .w-delete-widget .w-cancel": "handleRemoveWidgetCancelClick", 
                "click .w-delete-widget .w-confirm": "handleRemoveWidgetConfirmClick",
                "click .w-edit-widget": "handleEditWidgetClick",
                "click .w-settings .clone": "handleCloneWidget"
            }
        }, options));

        // Listen for widget updates (same pattern as chart widget)
        this.options.widget.on('sync', () => {
            // Check if size changed to trigger layout
            const oldSize = this.getWidgetSize();
            const newSize = Number(this.options.widget.getParamValue('CHART_SIZE', CHART_SIZE.SIZE_6));
            
            // Update widget size classes immediately (same as chart widget)
            for (var i = 1; i <= 6; i++) {
                if (i === newSize) {
                    this.$el.addClass('widget-w-' + i);
                } else {
                    this.$el.removeClass('widget-w-' + i);
                }
            }
            
            // Re-render the content
            this.render();
            
            // If size changed, trigger layout recalculation
            if (oldSize !== newSize) {
                App.Bus.trigger('dashboard:category:' + this.options.categoryId + ':layout');
            }
        });
    }

    protected getWidgetSize(): number {
        // Extract current widget size from DOM classes (same logic as chart widget)
        for (var i = 1; i <= 6; i++) {
            if (this.$el.hasClass('widget-w-' + i)) {
                return i;
            }
        }
        return 6; // Default fallback (SIZE_6)
    }

    render(): this {
        // Get the URL parameter from the widget
        const iframeUrl = this.options.widget.getParamValue('IFRAME_URL', '');
        
        this.$el.html(this.template({
            widget: this.options.widget,
            dashboardId: this.options.dashboardId,
            permissionCollection: this.options.permissionCollection,
            editable: this.options.editable,
            movable: this.options.movable,
            cloneable: this.options.cloneable,
            deletable: this.options.deletable,
            iframeUrl: iframeUrl
        }));

        // Set the widget ID attribute for Packery (only set this once during initial render)
        if (!this.$el.attr('data-widget-id')) {
            this.$el.attr('data-widget-id', this.options.widget.get('id'));
            
            // Set initial size class (only on first render)
            this.$el.addClass('widget-w-' + this.options.widget.getParamValue('CHART_SIZE', CHART_SIZE.SIZE_6));
        }

        this.delegateEvents();
        
        return this;
    }
}


// WEBPACK FOOTER //
// ./srv/public/js/views/dashboard/widgets/iframe/IframeWidget.ts